var img = "data:image/svg+xml,%3csvg height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='m11.718 11.01 6.01-6.01.707.707-6.01 6.01 6.01 6.01-.707.708-6.01-6.01-6.01 6.01-.708-.707 6.01-6.01-6.01-6.01.707-.708 6.01 6.01z' fill='currentColor' fillRule='evenodd'/%3e%3c/svg%3e";

export default img;
//# sourceMappingURL=cross.svg.js.map
